import { useCallback } from "react";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { setSelectedUser } from "../redux/slices/selected-user-slice";
import { ChatUser } from "../api/user-request";

export const useSelectedUser = () => {
  const dispatch = useAppDispatch();
  const selectedUser = useAppSelector((state) => state.selectedUser.value);

  const setUser = useCallback(
    (user: ChatUser) => {
      dispatch(setSelectedUser(user));
    },
    [dispatch],
  );

  return { selectedUser, setSelectedUser: setUser };
};
